import React, { useEffect, useState } from "react";
import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import { useAuth } from "../../auth/auth";
import { useForm } from "react-hook-form";
import { getMyProfileData, updateProfile } from "../../api/apiCall";
import { toast } from "react-toastify";

type FormValuesEditProfile = {
    name: string;
    surname: string;
    username: string;
    email: string;
    phoneNumber: string;
    pts: string;
    postCode: string;
    location: string;
}

const EditProfile = () => {
    const {state} = useAuth();
    const [profileData, setProfileData] = useState<any>();

    const {register, handleSubmit, reset} = useForm<FormValuesEditProfile>();

    const onSubmit = async (data: any) => {
        const response = await updateProfile(state.user?.token, data);
        if(response === 200) {
            toast.success("Updated successfully")
        }
    }

    const getProfileData = async () => {
        const response = await getMyProfileData(state.user?.token);
        setProfileData(response);
    }

    useEffect(() => {
        getProfileData();
    }, []);

    useEffect(() => {
        reset(profileData)
    }, [profileData]);

    return (
        <Box sx={{
            backgroundColor: "#fff",
            padding: "50px",
            margin: "auto",
            background: "#fff",
            border: '1px solid rgb(236, 236, 236)',
        }}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={2}>
                    <Typography color={"primary.dark"}>Name</Typography>
                </Grid>
                <Grid item xs={12} sm={10}>
                    <TextField
                        size="small"
                        sx={{width: '400px'}}
                        {...register("name")}
                        disabled
                    />
                </Grid>

                <Grid item xs={12} sm={2}>
                    <Typography color={"primary.dark"}>Surname</Typography>
                </Grid>
                <Grid item xs={12} sm={10}>
                    <TextField
                        size="small"
                        sx={{width: '400px'}}
                        {...register("surname")}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <Typography color={"primary.dark"}>Username</Typography>
                </Grid>
                <Grid item xs={12} sm={10}>
                    <TextField
                        size="small"
                        sx={{width: '400px'}}
                        {...register("username")}
                        disabled
                    />
                </Grid>

                <Grid item xs={12} sm={2}>
                    <Typography color={"primary.dark"}>Email</Typography>
                </Grid>
                <Grid item xs={12} sm={10}>
                    <TextField
                        size="small"
                        sx={{width: '400px'}}
                        {...register("email")}
                    />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <Typography color={"primary.dark"}>Phone Number</Typography>
                </Grid>
                <Grid item xs={12} sm={10}>
                    <TextField
                        size="small"
                        sx={{width: '400px'}}
                        {...register("phoneNumber")}
                    />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <Typography color={"primary.dark"}>PTS</Typography>
                </Grid>
                <Grid item xs={12} sm={10}>
                    <TextField
                        size="small"
                        sx={{width: '400px'}}
                        {...register("pts")}
                    />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <Typography color={"primary.dark"}>Post Code</Typography>
                </Grid>
                <Grid item xs={12} sm={10}>
                    <TextField
                        size="small"
                        sx={{width: '400px'}}
                        {...register("postCode")}
                    />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <Typography color={"primary.dark"}>Location</Typography>
                </Grid>
                <Grid item xs={12} sm={10}>
                    <TextField
                        size="small"
                        sx={{width: '400px'}}
                        {...register("location")}
                    />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <Typography />
                </Grid>
                <Grid item xs={12} sm={10} mt={4}>
                    <Button
                        variant="contained"
                        style={{boxShadow: "none"}}
                        onClick={handleSubmit(onSubmit)}
                    >
                        Save Changes
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
}

export default EditProfile;
